import React, { useRef, useEffect, useState } from 'react';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';
import type { PdfPresenterExtendProps } from './PdfPresenter';

type PdfInIframeProps = PdfPresenterExtendProps & {
	className?: string;
	style?: React.CSSProperties;
	onError?: (error: string) => void;
};

export const PdfInIframe = ({ title, src, className, style, onError }: PdfInIframeProps) => {
	const { t } = useTranslation();
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const [error, setError] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (!iframeRef.current) return;

			try {
				const iframeDoc = iframeRef.current.contentDocument;
				if (!iframeDoc || iframeDoc.body?.children.length === 0) {
					setError(true);
					onError?.('PDF not rendered – possibly unsupported on this device.');
				}
			} catch (err) {
				//
			}
		}, 5000);

		return () => clearTimeout(timeout);
	}, [src, onError]);

	return (
		<iframe
			ref={iframeRef}
			title={title}
			src={src}
			className={classNames('iframe-view iframe-pdf', className)}
			style={style}
			onError={(error) => {
				if (onError) {
					onError(String(error));
				}
			}}
			width="100%"
			height="500px"
		>
			{t('misc.iframeLoadError')}
		</iframe>
	);
};
